interface Props {
    canBuy?: string | boolean | null
    canSell?: string | boolean | null
}

export const formatBuySellStatus = (status: Props | undefined | null): string => {
    if (!status) {
        return ''
    }

    const { canBuy, canSell } = status

    const canBuyIsYes = typeof canBuy === 'string' ? canBuy.toLowerCase() === 'yes' : false
    const canSellIsYes = typeof canSell === 'string' ? canSell.toLowerCase() === 'yes' : false

    switch (true) {
        case (canBuyIsYes && canSellIsYes) || (canBuy === true && canSell === true):
            return 'Buyer/Seller'
        case canBuyIsYes || canBuy === true:
            return 'Buyer'
        case canSellIsYes || canSell === true:
            return 'Seller'
        default:
            return ''
    }
}
